<!-- Trigger Button -->
<button
  #triggerButton
  type="button"
  [class]="triggerClasses()"
  [disabled]="disabled()"
  (click)="toggle()">
  
  <!-- Selected Value -->
  <span 
    class="truncate"
    [class.text-gray-900]="selectedOption()"
    [class.text-gray-500]="!selectedOption()">
    {{ displayText() }}
  </span>
  
  <!-- Chevron Icon -->
  <svg 
    class="w-5 h-5 text-gray-400 flex-shrink-0 transition-transform duration-200"
    [class.rotate-180]="isOpen()"
    fill="none" 
    stroke="currentColor" 
    viewBox="0 0 24 24">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
  </svg>
</button>

<!-- Dropdown Panel (CDK Overlay) -->
<ng-template #dropdownTemplate>
  <div class="bg-white border border-gray-200 rounded-lg shadow-lg overflow-hidden w-60">
    <!-- Options List -->
    <div class="max-h-60 overflow-y-auto py-1 w-60">
      @for (option of options(); track option.value) {
        <button
          type="button"
          class="w-full px-2 py-2 text-left flex items-center gap-3 transition-colors hover:bg-gray-50"
          [class.bg-brand-purple-50]="option.value === value()"
          (click)="select(option)">
          
          <!-- Check Icon (selected) -->
          @if (option.value === value()) {
            <svg class="w-3 h-3 text-brand-purple-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
            </svg>
          } @else {
            <div class="w-3 h-3 flex-shrink-0"></div>
          }
          
          <!-- Option Content -->
          <div class="flex-1 min-w-0">
            <div 
              class="truncate text-xs"
              [class.text-brand-purple-700]="option.value === value()"
              [class.font-medium]="option.value === value()"
              [class.text-gray-900]="option.value !== value()">
              {{ option.label }}
            </div>
            @if (option.sublabel) {
              <div class="text-xs text-gray-500 truncate">{{ option.sublabel }}</div>
            }
          </div>
        </button>
      } @empty {
        <div class="px-4 py-3 text-sm text-gray-500 text-center">
          No options available
        </div>
      }
    </div>
  </div>
</ng-template>
